import React, {Component} from 'react';
import HGTradeCount from "./HGTradingActivity/HGTradeCount";
import HGTradeCountShare from "./HGTradingActivity/HGTradeCountShare";
import HGTradeVolume from "./HGTradingActivity/HGTradeVolume";
import HGTradeVolumeShare from "./HGTradingActivity/HGTradeVolumeShare";

class HGTradingActivity extends Component {
    state = {
        selectedChart: 0
    };

    render() {
        return (
            <React.Fragment>
                {this.state.selectedChart === 0 && (
                    <HGTradeCount/>
                )}
                {this.state.selectedChart === 1 && (
                    <HGTradeCountShare/>
                )}
                {this.state.selectedChart === 2 && (
                    <HGTradeVolume/>
                )}
                {this.state.selectedChart === 3 && (
                    <HGTradeVolumeShare/>
                )}
                <ul style={{textAlign: 'center', margin: '5px 0 0 0', padding: 0}}>
                    <li style={{display: 'inline-block', margin: '5px'}}>
                        <button className={`chartButton${this.state.selectedChart === 0 ? ' chartButton--selected' : ''}`}
                                onClick={() => this.setState({selectedChart: 0})}>
                            Trade Count
                        </button>
                    </li>
                    <li style={{display: 'inline-block', margin: '5px'}}>
                        <button className={`chartButton${this.state.selectedChart === 1 ? ' chartButton--selected' : ''}`}
                                onClick={() => this.setState({selectedChart: 1})}>
                            Trade Count Share
                        </button>
                    </li>
                    <li style={{display: 'inline-block', margin: '5px'}}>
                        <button className={`chartButton${this.state.selectedChart === 2 ? ' chartButton--selected' : ''}`}
                                onClick={() => this.setState({selectedChart: 2})}>
                            Trade Volume
                        </button>
                    </li>
                    <li style={{display: 'inline-block', margin: '5px'}}>
                        <button className={`chartButton${this.state.selectedChart === 3 ? ' chartButton--selected' : ''}`}
                                onClick={() => this.setState({selectedChart: 3})}>
                            Trade Volume Share
                        </button>
                    </li>
                </ul>
            </React.Fragment>
        );
    }
}

export default HGTradingActivity;



// WEBPACK FOOTER //
// ./frontend/components/Charts/MarketInsights/HGTradingActivity.jsx